export const isMainnet = process.env.NEXT_PUBLIC_IS_MAINNET === "true";
export const isLoggingEnabled = process.env.NEXT_PUBLIC_LOGGING === "true";
export const shouldLogErrors = process.env.NEXT_PUBLIC_LOG_ERRORS === "true";
